export enum TrendyolOrderStatus {
  CREATED = 'Created',
  CANCELLED = 'Cancelled',
}

export const trendyolOrderStatusNameMap: Record<TrendyolOrderStatus, string> = {
  [TrendyolOrderStatus.CREATED]: 'Sipariş Oluşturuldu',
  [TrendyolOrderStatus.CANCELLED]: 'İptal Edildi',
};

export const trendyolOrderStatusDescriptionMap: Record<
  TrendyolOrderStatus,
  string
> = {
  [TrendyolOrderStatus.CREATED]: 'Stok düşüldü',
  [TrendyolOrderStatus.CANCELLED]: 'Stok geri eklendi',
};
